import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  SET_SELECTED_CATEGORY
} from './types';
import DataManager from '../../data/DataManager';

export const SET_CATEGORIES = "SET_CATEGORIES";

export const setCategories = (categories) => ({
  type: SET_CATEGORIES,
  payload: categories,
});

// 获取分类列表
export const fetchCategories = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_CATEGORIES_REQUEST });
    
    const categories = await DataManager.getCategories();
    if (categories.length === 0) {
      // 重新获取数据
      await DataManager.initialize();
    }
    
    dispatch({
      type: FETCH_CATEGORIES_SUCCESS,
      payload: DataManager.getCategories()
    });
  } catch (error) {
    console.error('Fetch categories error:', error);
    dispatch({
      type: FETCH_CATEGORIES_FAILURE,
      payload: error.message
    });
  }
};

// 设置选中的分类
export const setSelectedCategory = (categoryId) => ({
  type: SET_SELECTED_CATEGORY,
  payload: categoryId
});
